import { Component, OnInit, ElementRef, ViewChild, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'app/users/shared/user.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { UtilService } from 'app/hrms/shared/util.service';
@Component({
  selector: 'app-salary',
  templateUrl: './salary.component.html',
  styleUrls: ['./salary.component.scss']
})
export class SalaryComponent implements OnInit {
  @ViewChild('testdiv') el:ElementRef;
  @Input('uid') uid:any;
  @Input('month') month:any;
  user:any;
  donotDisplay:boolean = false;
  date:Date;
  year:any;
  constructor(private router:ActivatedRoute, private userService:UserService, private ls:LogisticsService, private hrmsService:HRMSService, private util:UtilService) { 
    this.date = new Date();
    this.year = this.date.getFullYear();
    this.router.params.subscribe((params) => {
      if(params['id']!=null)
      {
        this.uid  = params['id'];
        this.month = Number(params['month']);
        this.year = Number(params['year']?params['year']:this.year);
      }
    });
  }

  ngOnInit() {
    this.getUserDetails();
  }
  getUserDetails()
  {
    this.donotDisplay = false;
    this.userService.getUser(this.uid).on("value",(data)=>{
      this.user = data.val();
      this.ls.getBranchName(this.user.branch).once("value").then(branch=>{
        this.user.branch = branch.child("name").val();
      });
      this.hrmsService.getDepartmentName(this.user.department).once("value").then(department=>{
        this.user.department = department.child("name").val();
      });
      this.hrmsService.getDesignationName(this.user.designation).once("value").then(designation=>{
        this.user.designation = designation.child("name").val();
      });
      this.userService.getUser(this.user.reportingTo).once("value").then(reportingTo=>{
        this.user.reportingTo = reportingTo.child("firstName").val();
      });
    });
      this.hrmsService.getUserSalaryForMonth(this.year,Number(this.month),this.uid).on("value",(data)=>{
        if(data.val() == null)
        {
          this.donotDisplay = true;
        }
        else
        {
          this.user.salaryComponent = data.val();
          var salary = data.val();
          //Gross Salary
          var gross = Number(salary.basic) + Number(salary.hra?salary.hra:0) + Number(salary.da?salary.da:0) + Number(salary.others?salary.others:0) + Number(salary.medicalAllowance?salary.medicalAllowance:0)
          + Number(salary.allowance?salary.allowance:0) + Number(salary.conveyance?salary.conveyance:0) + Number(salary.overtime?salary.overtime:0);
          this.user.salaryComponent.gross = Number(Number(gross).toFixed(2));
          //Deduction
          var deduction = Number(salary.pf?salary.pf:0) + Number(salary.tax?salary.tax:0) + Number(salary.tds?salary.tds:0);
          //Net Salary
          var netSalary = gross - deduction;
          netSalary = Number(Number(netSalary).toFixed(2));
          //Loss Of Pay
          var perDay = Number(netSalary) / 31 ;
          var lossofpay = 0;
          if(salary.leaves)
          {
           lossofpay =  Number((perDay * Number(salary.leaves)).toFixed(2));
          }
          this.user.salaryComponent.lossofpay = lossofpay;
          this.user.salaryComponent.deduction = Number(Number(deduction).toFixed(2)) + lossofpay;
          this.user.salaryComponent.inWords = this.util.inWords(Number(salary.computedSalary?salary.computedSalary:this.user.salary).toFixed(0));
        }
      });
  }

ngOnChanges(changes: SimpleChanges) {
  // only run when property "data" changed
  if (changes['month']) {
    //console.log("month",this.month);
    this.getUserDetails();
  }
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/payroll/salary/salary.component.ts